import { Controller } from "@hotwired/stimulus";

/**
 * GO4S Design System — drawer Juju (assistant IA).
 * Slide-over à droite ; charge le chat (iframe) au premier ouverture seulement.
 */
export default class extends Controller {
  static targets = ["frame", "panel"];

  open() {
    if (this.hasFrameTarget && !this.frameTarget.src && this.frameTarget.dataset.src) {
      this.frameTarget.src = this.frameTarget.dataset.src;
    }
    this.element.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }

  close() {
    this.element.classList.remove("is-open");
    document.body.style.overflow = "";
  }
}
